<template>
  <!-- 弹出模式的登录注册模块 -->
  <a-modal
    v-model="modalVisible"
    :body-style="{
      padding: '0',
    }"
    :footer="null"
    :width="730"
    :z-index="1003"
    @cancel="cancelModal"
  >
    <div class="content">
      <div class="downLoadSide">
        <v-img :src="PIC_LOGO" alt="PIC_LOGO" class="logo" style="width: 75px" width="75" />
        <p class="p1">
          {{ $t('下载云展动力APP') }}
        </p>
        <p :style="$store.state.locale === 'en' ? 'font-size: 14px;line-height: 15px;' : ''" class="p2">
          {{ $t('数字孪生精准获客平台') }}
        </p>
        <v-img :src="APP_DOWNLOAD" alt="下载按钮" style="width: 126px" width="126" />
        <p v-if="$store.state.locale === 'en'" class="p3">Scan to download</p>
        <p v-else class="p3">扫码下载<br />云展动力 App</p>
      </div>
      <div class="tabCont">
        <div v-show="tabsModel === 'login' || tabsModel === 'verifiCodeLogin'" class="tabLink">
          <div :class="tabsModel === 'login' ? 'linkTabItem' : ''" class="tabItem" @click="switchTabs('login')">
            {{ $t('密码登录') }}
          </div>
          <div
            :class="tabsModel === 'verifiCodeLogin' ? 'linkTabItem' : ''"
            class="tabItem"
            @click="switchTabs('verifiCodeLogin')"
          >
            {{ $t('验证码登录') }}
          </div>
        </div>
        <Register v-if="tabsModel === 'register'" back-path="reload" @switchTabs="switchTabs" />
        <Login v-else-if="tabsModel === 'login'" @switchTabs="switchTabs" />
        <VerifiCodeLogin v-if="tabsModel === 'verifiCodeLogin'" back-path="reload" @switchTabs="switchTabs" />

        <FindPwd v-else-if="tabsModel === 'findPwd'" back-path="reload" @switchTabs="switchTabs" />
        <WechatLogin v-else-if="tabsModel === 'wechatLogin'" :back-path="$route.fullPath" @switchTabs="switchTabs" />
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import Login from './Login.vue'
import Register from './Register.vue'
import FindPwd from './findPwd.vue'
import WechatLogin from './wechatLogin.vue'
import VerifiCodeLogin from './verifiCodeLogin.vue'
import { APP_DOWNLOAD, PIC_LOGO } from '@/const/image'

export default {
  name: 'PopUpLogin',
  components: {
    Login,
    Register,
    FindPwd,
    WechatLogin,
    VerifiCodeLogin,
  },
  data() {
    return {
      PIC_LOGO,
      APP_DOWNLOAD,
    }
  },
  computed: {
    ...mapGetters({
      // 是否登录成功
      isWebIMLogin: 'chat/isWebIMLogin',
    }),

    modalVisible: {
      get() {
        return !!this.$store.state.popupLoginStatus
      },
      set(value) {
        console.log('value', value)
      },
    },
    tabsModel() {
      return this.$store.state.popupLoginStatus || 'login'
    },
  },
  created() {
    // console.log('popuplogin created', this.$route)
  },
  methods: {
    // 切换tabs
    switchTabs(e) {
      console.log('切换tabs', e)
      this.$store.commit('switchPopupLoginStatus', e)
    },
    // 关闭弹窗
    cancelModal() {
      console.log('关闭弹窗', this.tabsModel)
      if (this.tabsModel === 'findPwd') {
        // 如果现在已经登录, 则关闭弹窗
        if (this.isWebIMLogin) {
          this.$store.commit('switchPopupLoginStatus', false)
        } else {
          // 如果现在没有登录, 则切换到登录模式
          this.$store.commit('switchPopupLoginStatus', 'login')
        }
        // this.$store.commit('switchPopupLoginStatus', 'login');
      } else {
        this.$store.commit('switchPopupLoginStatus', false)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  position: relative;
  width: 100%;
  min-height: 540px;
  display: flex;
  background: #fef8f5;

  .downLoadSide {
    position: relative;
    top: 0;
    left: 0;
    width: 330px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    p {
      margin-bottom: 0;
    }

    .p1 {
      font-size: 24px;
      font-weight: bold;
      color: #ff6600;
      line-height: 24px;
      margin-bottom: 12px;
    }

    .p2 {
      font-size: 22px;
      font-weight: 400;
      color: #ff6600;
      line-height: 32px;
      margin-bottom: 25px;
    }

    .p3 {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
      margin-top: 15px;
    }
  }

  .tabCont {
    width: 400px;
    padding: 0 24px;
    background: #fff;

    .tabLink {
      display: flex;

      .tabItem {
        height: 60px;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: #666666;
        line-height: 60px;
        margin-right: 24px;
      }

      .linkTabItem {
        color: #ff7e00;
        font-weight: 600;
        border-bottom: 2px solid #ff6600;
      }
    }
  }
}
</style>
